import { createFileRoute } from '@tanstack/react-router';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { VStack } from 'ui_2';
import { Route as index_route } from '@routes/index';
import {
  CurrentGiveawayHistory,
  PastGiveawayHistory,
} from '@src/components/giveaway/GiveawayHistoryRows';
import { z } from 'zod';
import {
  FilterButtonOption,
  FilterButtons,
} from '@src/components/FilterButtons';
import { useState } from 'react';
import { Page } from '@src/components/layout/Page';

enum Filter {
  Current = 'current',
  Past = 'past',
}

const filterOptions: FilterButtonOption[] = [
  {
    label: 'Current',
    value: Filter.Current,
  },
  {
    label: 'Past',
    value: Filter.Past,
  },
];

const giveawayHistorySchema = z.object({
  filter: z.enum([Filter.Current, Filter.Past]).default(Filter.Current),
});

export const Route = createFileRoute('/giveaways/history')({
  staticData: { title: 'Giveaway Overview' },
  validateSearch: giveawayHistorySchema,
  component: function Component() {
    const { isPuzzleWalletWebview } = useArcadeStoreState();

    const { filter } = Route.useSearch();
    const [value, setValue] = useState(filter);
    const navigate = Route.useNavigate();

    return (
      <Page
        title={'Your Giveaway Entries'}
        showFooter={!isPuzzleWalletWebview}
        backRoute={index_route.to}
      >
        <VStack className={`w-full justify-center gap-4 pb-8`}>
          <FilterButtons
            defaultValue={value}
            options={filterOptions}
            onChange={(value) => {
              setValue(value as Filter);
              navigate({
                search: {
                  filter: value as Filter,
                },
              });
            }}
          />
          {filter === Filter.Current ? (
            <CurrentGiveawayHistory />
          ) : (
            <PastGiveawayHistory />
          )}
        </VStack>
      </Page>
    );
  },
});
